import Jakub from '@/assets/img/jakub.jpg';

export const CONSULTANTS = {
  JAKUB_ASSISTANT: {
    name: 'Jakub Grobelny',
    image: Jakub,
    jobDescription: 'Radca prawny',
  },
} as const;

export const PRODUCTS_WITH_GUARDIAN = [36, 75];
